import { currentUserIDState, isMasterState } from '@atom/setting/user';
import UserSec, { Tag } from '@components/navigation/common/UserSec';
import { useDocument } from '@nandorojo/swr-firestore';
import { userLogout } from '@store/firebase/user/registerUser';
import { User } from '@typings/setting/userType.interface';
import React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import styled from 'styled-components';
import Avatar from '@components/dataDisplay/Avatar';
import { useNavigate } from 'react-router-dom';
import { RootPath } from '@routes/routePath';
import { AUTH_TYPE_MAP } from '@typings/common/authorizationType';

const InfoSec = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: auto 1fr;
  width: 100%;
`;

const BtnWrap = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  span {
    font-size: 0.8rem;
  }
`;

const Btn = styled.button`
  display: inherit;
  padding: 2px;
  border-radius: var(--cardBorderRadius);
  font-family: var(--defaultFontFamily);
  color: var(--subTextColor);
  font-size: 0.8rem;

  &:hover {
    font-weight: 700;
  }
`;

const DisplaNameSec = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
`;

type Props = {};
function UserInfoCard({}: Props) {
  const history = useNavigate();
  const [currentUid, setCurrentUid] = useRecoilState(currentUserIDState);
  const isMaster = useRecoilValue(isMasterState);
  function logout() {
    userLogout();
    setCurrentUid(null);
  }

  const { data: userData, error } = useDocument<User>(`users/${currentUid}`, {
    listen: true,
  });

  if (!userData) return null;

  const { displayName, photoURL, authorizationType } = userData;

  return (
    <>
      <InfoSec>
        <UserSec
          showDisplayName={false}
          size={'60px'}
          dropdownDir={'leftBottom'}
        />

        <div style={{ width: '100%' }}>
          <Tag>{AUTH_TYPE_MAP[authorizationType]}</Tag>
          <DisplaNameSec>{displayName}</DisplaNameSec>
          <BtnWrap>
            <Btn
              onClick={() =>
                history(`${RootPath.User}/${currentUid}/${RootPath.UserDetail}`)
              }
            >
              내 계정
            </Btn>
            {isMaster && (
              <>
                <span>∙</span>
                <Btn
                  onClick={() =>
                    history(`/${RootPath.Setting}/${RootPath.Homepage}`)
                  }
                >
                  설정
                </Btn>
              </>
            )}
            <span>∙</span>
            <Btn onClick={logout}>로그아웃</Btn>
          </BtnWrap>
        </div>
      </InfoSec>
    </>
  );
}

export default UserInfoCard;
